import './AboutUs.css';


const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1>About Us</h1>
        <p>Makhentsa cc is a fully Black Owned Company with a fast growing customer base
          since registered under section 14 of the company act, 2008. We are committed to rendering quality
          services which meet the requirements and expectations of our clients to their satisfaction.
        </p>

        <p>We aim to have a positive impact on our country's socio-economic standards through social
          investments, job creation and capacity building. We will work inexorably in achieving 
          world-class standards of opennes and transparency towards all stakeholders.
          
        </p>
      </div>

    </div>
  );
};

export default AboutUs;
